import { ModalClose } from "../modalToggle";
const tagSubmitClass: string = "js-room-info-tag-submit";
const tagInputClass: string = "js-room-info-tag";
const tagListClass: string = "js-room-info-tag-list";
const tagListWrapClass: string = "c-room-info__tag__list";
const hiddenClass: string = "u-display--none";
document.addEventListener("click", (event: any) => {
  const tagSubmit: HTMLElement = event.target.closest(`.${tagSubmitClass}`)!;
  if (tagSubmit) {
    const tagInputs: NodeListOf<HTMLInputElement> = document.querySelectorAll(`.${tagInputClass}`)!;
    TagCheck(tagInputs);
    ModalClose();
  }
})

const TagCheck = (inputs: NodeListOf<HTMLInputElement>) => {
  let trueIndex = 0;
  for(let i = 0; inputs.length > i; i ++) {
    const tagValue: string = String(inputs[i].dataset.value);
    console.log(tagValue);
    const hitTag: HTMLElement = document.querySelector(`.${tagListClass}[data-value="${tagValue}"]`)!;
    if (inputs[i].checked) {
      hitTag.classList.remove(hiddenClass);
      trueIndex ++;
    } else {
      hitTag.classList.add(hiddenClass);
    }
  }
  const listWrap: HTMLElement = document.querySelector(`.${tagListWrapClass}`)!;
  if (trueIndex > 0) {
    listWrap.classList.remove(hiddenClass);
  } else {
    listWrap.classList.add(hiddenClass);
  }
}
